enum ApiSourceEnum {
    Surveys = '/api/Survey/GetAll',
    Survey = '/api/Survey/Get',
    DeleteRespondents = '/api/Survey/DeleteRespondents',
    RegenerateSurvey = '/api/Survey/RegenerateSurvey',
    GetUser = '/api/User/GetUser',
}

export default ApiSourceEnum;